export const SITES_DEMAND_QUERY = `
    query DemandQuery ($perPage: Int) {
        sites(per_page: $perPage) {
            id
            demand {
                average
                readings {
                    value
                    end_time
                    start_time
                }
                max
                min
            }
            display_labels {
                label
                locale
            }
        }
    }
`